import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormItemComponentInterface} from '../../../../interface/component';
import {NoosFormTypeService} from '../../../../class/NoosFormTypeService';
import {IFormItemsControls} from '../../../../interface/form-structure';

@Component({
    selector: 'noos-slide-toogle',
    templateUrl: './slide-toogle.component.html',
    styleUrls: ['./slide-toogle.component.scss']
})
@NoosFormTypeService.register('slide')
export class SlideToogleComponent implements OnInit, AfterViewInit, FormItemComponentInterface {

    prop: IFormItemsControls;
    isFilter: boolean;

    @Output()
    keyOnEnter: EventEmitter<any> = new EventEmitter<any>();

    @Input()
    datasetId = 0;

    @Input()
    formId = 0;

    constructor() {
    }

    ngOnInit() {
        this.prop.defaultValue = this.prop.defaultValue || this.isFilter;
    }


    ngAfterViewInit(): void {
    }


    onChange(event) {
        this.prop.defaultValue = (!!event.checked);
    }


}
